module.exports = __webpack_public_path__ + "img/beans-shopping.cb3ea94b.png";